module.exports = __webpack_public_path__ + "img/icon-under-review.svg";